import React, { useState } from "react";
import { StaticImage } from "gatsby-plugin-image";
import addToMailchimp from "gatsby-plugin-mailchimp";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { utils } from "@core/helper";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { Link } from "gatsby";
import { useStaticQuery, graphql } from "gatsby";

const validationSchema = Yup.object().shape({
  email: Yup.string().email("Please Enter a Email").label("Email").required(),
});

const Footer = () => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "company-brochure-v2.pdf" }) {
        publicURL
      }
    }
  `);
  const { publicURL } = data.file;
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const handleSubscribe = async (values) => {
    try {
      setLoading(true);
      const { email } = values;
      const resp = await addToMailchimp(email);
      if (resp.result === "success") {
        utils.showSuccssMsg(resp?.msg);
        setLoading(false);
        reset();
      } else {
        utils.showErrMsg(resp?.msg);
        setLoading(true);
      }
    } catch (error) {
      console.error("er::", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer>
      <Container fluid className="footer-custom-container">
        <div className="footer-bg container-fluid">
          <div className="footer-form">
            <div className="subscribe-lhs">
              {/* <Link to={Pdf} target='_blank'>Read pdf</Link> */}
              <h6 className="subscribe_text">Let's engage</h6>
            </div>
            <div className="d-flex flex-column gap-2 justify-content-between">
              <form
                autoComplete="on"
                onSubmit={handleSubmit(handleSubscribe)}
                className="form-in"
              >
                <input
                  type="email"
                  placeholder="Enter your email"
                  {...register("email")}
                />
                <button name="Sign Up for Newsletter" type="submit" aria-label="Email">
                  {loading && (
                    <Spinner
                      className="footer-spinner"
                      animation="border"
                      variant="dark"
                    />
                  )}
                  {!loading && (
                    <svg
                      className="send-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      width="48"
                      height="49"
                      viewBox="0 0 48 49"
                      fill="none"
                    >
                      <circle cx="24" cy="24.9336" r="24" fill="#7534fc" />
                      <path
                        d="M14.5404 25.2606C13.794 25.6522 13.8249 26.2257 14.6075 26.5354L16.9262 27.4528C17.7095 27.7638 18.8946 27.5941 19.5585 27.0761L29.6275 19.1354C30.2895 18.6148 30.3604 18.6916 29.7856 19.307L21.8256 27.827C21.2488 28.4406 21.4191 29.1941 22.2049 29.498L22.4766 29.6038C23.2624 29.9077 24.543 30.418 25.3237 30.7354L27.8953 31.7825C28.6766 32.0999 29.5114 31.7257 29.7333 30.9128L33.6527 16.5064C33.874 15.6935 33.4443 15.3483 32.6978 15.7393L14.5404 25.2606Z"
                        fill="white"
                      />
                      <path
                        d="M20.9037 34.6921C20.8579 34.8295 22.4895 32.3295 22.4895 32.3295C22.9508 31.625 22.6888 30.7844 21.9095 30.4657L20.1301 29.7373C19.3508 29.4186 18.9772 29.7928 19.2998 30.5715C19.2998 30.5715 20.9508 34.5508 20.9037 34.6921Z"
                        fill="white"
                      />
                    </svg>
                  )}
                </button>
              </form>

              <span
                // className={
                //   errors?.email?.message
                //     ? "bg-white rounded fs-5 fw-bold text-danger p-2"
                //     : ""
                // }
                className="text-white fw-bold fs-4 ms-5 pt-2"
              // style={{ color: "white", marginTop: "10px" }}
              >
                {errors?.email?.message}
              </span>
            </div>
          </div>

          <Row className="footer-row-second">
            <Col
              xs={12}
              sm={6}
              md={8}
              lg={9}
              xl={3}
              xxl={3}
              className="footer-first"
            >
              <Link to="/">
                <StaticImage
                  src="../../styles/assets/images/Logo/Justtrylogo-whitebg.png"
                  alt="Justtry Logo"
                  style={{
                    width: "200px",
                  }}
                />
                {/* <img className="w-100" src={logo} alt="Justtry-Logo" /> */}
              </Link>
              <h6 className="text-start">
                179/3, Kamarajar salai,
                <br /> (Near Tamilnadu Chamber of Commerce), Madurai – 625009.
              </h6>

              <div className="d-flex align-items-start text-nowrap">
                <h6>
                  <strong> Career : </strong>{" "}
                </h6>
                <a
                  className="contact-div footer-link career"
                  target="_blank"
                  rel="noreferrer"
                  href="mailto:justtrytechnologies@gmail.com"
                  aria-label="Reach Justty and build your website"
                >
                  &nbsp; justtrytechnologies@gmail.com
                </a>
              </div>
            </Col>
            <Col
              xs={12}
              sm={6}
              md={4}
              lg={3}
              xl={2}
              xxl={2}
              className="footer_second_new"
            >
              <h5>Services</h5>
              <a href="/web3-development-company/">
                <p>Web3 Development </p>
              </a>
              <a href="/custom-web-development-company/">
                <p>Web2 Development </p>
              </a>
              <a href="/smart-contract-development-company/">
                <p>Smart Contract </p>
              </a>
              <a href="/cryptocurrency-mlm-software-development/">
                <p>MLM Development </p>
              </a>
              <a href="/enterprise-blockchain-development/">
                <p>Blockchain Development </p>
              </a>
              <a href="/nft-development-company/">
                <p>NFT Development </p>
              </a>
              <a href="/defi-development-company/">
                <p>DeFi </p>
              </a>
            </Col>
            <Col
              xs={12}
              sm={6}
              md={4}
              lg={4}
              xl={2}
              xxl={2}
              className="footer_solutions"
            >
              <h5>Solutions</h5>
              <a href="/cryptocurrency-exchange-development-company/">
                <p>Crypto Exchange </p>
              </a>
              <a href="/decentralized-exchange-development/">
                <p>Decentralized </p>
              </a>
              <a href="/centralized-crypto-exchange-development/">
                <p>Centralized </p>
              </a>
              <a href="/p2p-crypto-exchange-development/">
                <p>P2P Crypto Exchange </p>
              </a>
              <a href="/white-label-crypto-exchange-development/">
                <p>White-Label Crypto </p>
              </a>
              <a href="/nft-marketplace-development-company/">
                <p>NFT Game </p>
              </a>
              <a href="/blog/exclusive-complete-guide-decentralized-finance/">
                <p>Defi Exchange </p>
              </a>
            </Col>
            <Col
              xs={12}
              sm={6}
              md={4}
              lg={4}
              xl={2}
              xxl={2}
              className="footer-second"
            >
              <h5>Company</h5>

              <div className="company-link">
                <p>
                  <Link className="footer-link" to="/blog/">
                    Blogs
                  </Link>
                </p>
              </div>

              <div className="company-link">
                <p>
                  <Link className="footer-link" to="/terms-condition/">
                    Terms & Conditions
                  </Link>
                </p>
              </div>
              <div className="company-link">
                <p>
                  <Link className="footer-link" to="/privacy-policy/">
                    Privacy Policy
                  </Link>
                </p>
              </div>
              <div className="company-link">
                <p>
                  <a
                    className="footer-link"
                    href="/docs/company-brochure-v2.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Brochure
                  </a>
                </p>
              </div>
              <div className="company-link">
                <p>
                  <Link className="footer-link" to="/contact-us/">
                    Contact us
                  </Link>
                </p>
              </div>
              <div className="company-link">
                <p>
                  <Link className="footer-link" to="/careers/">
                    Careers
                  </Link>
                </p>
              </div>
            </Col>
            <Col
              xs={12}
              sm={6}
              md={4}
              lg={4}
              xl={3}
              xxl={3}
              className="footer-third"
            >
              <h5>Contact us</h5>
              <a
                className="contact-div"
                target="_blank"
                rel="noreferrer"
                href="https://wa.me/+919500139200"
                aria-label="Reach Justty and build your website"
              >
                <svg
                  className=""
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="black"
                >
                  <path
                    d="M15 0C6.72361 0 0 6.72361 0 15C0 17.6603 0.729579 20.143 1.94633 22.3102L0.0242018 29.172C-0.00650604 29.2819 -0.00789353 29.3978 0.0201777 29.5083C0.0482489 29.6188 0.104798 29.72 0.184187 29.8019C0.263575 29.8837 0.36303 29.9433 0.472634 29.9747C0.582238 30.0061 0.698162 30.0083 0.808849 29.9809L7.96366 28.2078C10.0661 29.3302 12.4517 30 15 30C23.2764 30 30 23.2764 30 15C30 6.72361 23.2764 0 15 0ZM15 1.30435C22.5714 1.30435 28.6957 7.42857 28.6957 15C28.6957 22.5714 22.5714 28.6957 15 28.6957C12.5726 28.6957 10.2992 28.0628 8.32286 26.9569C8.17831 26.8762 8.00846 26.8534 7.84774 26.8933L1.58203 28.446L3.26214 22.4516C3.28618 22.3669 3.29282 22.2782 3.28166 22.1908C3.27049 22.1035 3.24176 22.0193 3.19718 21.9434C1.9961 19.9067 1.30435 17.537 1.30435 15C1.30435 7.42857 7.42857 1.30435 15 1.30435ZM9.54951 7.17391C9.13144 7.17391 8.53438 7.32945 8.0439 7.85793C7.74931 8.17536 6.52174 9.37142 6.52174 11.4742C6.52174 13.6665 8.04221 15.5582 8.22605 15.8012H8.22733V15.8025C8.20989 15.7796 8.46067 16.1427 8.79543 16.5782C9.13019 17.0137 9.59831 17.5856 10.1864 18.2048C11.3626 19.4432 13.0163 20.8744 15.0688 21.7497C16.014 22.1522 16.7597 22.3953 17.3246 22.5726C18.3716 22.9014 19.3253 22.8514 20.0416 22.7458C20.5778 22.6669 21.1675 22.4094 21.751 22.0402C22.3345 21.6709 22.9064 21.2118 23.1585 20.5142C23.3392 20.0141 23.431 19.5519 23.4643 19.1716C23.4809 18.9815 23.483 18.8137 23.4706 18.6583C23.4582 18.5029 23.4715 18.3839 23.3267 18.1462C23.0231 17.6477 22.6792 17.6347 22.3204 17.4571C22.121 17.3585 21.5535 17.0813 20.9842 16.81C20.4156 16.5391 19.9232 16.2991 19.62 16.191C19.4284 16.1221 19.1945 16.0228 18.857 16.0611C18.5195 16.0993 18.1862 16.3428 17.9921 16.6304C17.8082 16.9031 17.0676 17.7772 16.8419 18.0341C16.8389 18.0323 16.8585 18.0413 16.7693 17.9972C16.4901 17.859 16.1486 17.7415 15.6433 17.4749C15.1379 17.2084 14.5058 16.8148 13.8141 16.205V16.2037C12.7846 15.2974 12.0634 14.1594 11.8359 13.7772C11.8513 13.7589 11.8341 13.781 11.8665 13.7492L11.8678 13.7479C12.1003 13.5189 12.3064 13.2453 12.4805 13.0448C12.7273 12.7603 12.8363 12.5096 12.9543 12.2754C13.1895 11.8085 13.0586 11.2948 12.9225 11.0245V11.0233C12.9319 11.042 12.8489 10.8588 12.7594 10.6475C12.6697 10.4356 12.5554 10.1609 12.4333 9.86795C12.1892 9.28207 11.9165 8.62494 11.7544 8.24006V8.23879C11.5634 7.78545 11.305 7.45885 10.9672 7.30129C10.6294 7.14373 10.3309 7.18852 10.3189 7.18792H10.3176C10.0765 7.1768 9.81198 7.17391 9.54951 7.17391ZM9.54951 8.47826C9.80095 8.47826 10.0488 8.48133 10.2565 8.491C10.47 8.50164 10.4568 8.50252 10.4157 8.48336C10.3739 8.46389 10.4306 8.45758 10.552 8.74575C10.7107 9.12262 10.9847 9.78212 11.2296 10.3698C11.3521 10.6637 11.4667 10.9394 11.5583 11.1557C11.6498 11.372 11.6994 11.4928 11.757 11.6079V11.6092L11.7582 11.6105C11.8147 11.7218 11.8097 11.6505 11.7901 11.6895C11.6525 11.9626 11.6338 12.0297 11.4946 12.19C11.2826 12.4342 11.0664 12.7066 10.9519 12.8193C10.8518 12.9177 10.6711 13.0709 10.5583 13.3708C10.4454 13.6712 10.4981 14.0834 10.6793 14.3911C10.9207 14.8008 11.7159 16.0952 12.9518 17.1833C13.7301 17.8694 14.4552 18.3234 15.0344 18.629C15.6136 18.9345 16.0854 19.113 16.191 19.1653C16.4417 19.2893 16.7156 19.3857 17.0342 19.3474C17.3528 19.3092 17.6275 19.1159 17.8023 18.9181L17.8036 18.9169C18.0363 18.6531 18.7277 17.8635 19.0595 17.3769C19.0736 17.3818 19.069 17.378 19.1793 17.4176V17.4189H19.1805C19.2309 17.4368 19.8615 17.7191 20.4237 17.987C20.986 18.2549 21.5567 18.5334 21.7421 18.6252C22.0097 18.7576 22.1362 18.8438 22.1688 18.8443C22.171 18.9016 22.1733 18.9638 22.165 19.0583C22.1421 19.3202 22.0721 19.6828 21.9319 20.0709C21.8632 20.2609 21.5054 20.6528 21.0543 20.9384C20.6031 21.2239 20.0539 21.4256 19.8505 21.4555C19.2391 21.5456 18.513 21.5785 17.7157 21.3281C17.1628 21.1546 16.4735 20.93 15.5808 20.5498C13.7705 19.7778 12.2319 18.464 11.1328 17.3068C10.5833 16.7282 10.143 16.1896 9.82974 15.7821C9.51709 15.3754 9.38056 15.1637 9.26673 15.014L9.26546 15.0127C9.06339 14.7455 7.82609 13.0245 7.82609 11.4742C7.82609 9.83347 8.58815 9.19007 9.00051 8.74575C9.21699 8.5125 9.45366 8.47826 9.54951 8.47826Z"
                    fill="white"
                  />
                </svg>
                <p>(+91) 9500 139 200</p>
              </a>
              <a
                className="contact-div footer-link"
                href="https://t.me/justtrytech"
                target="_blank"
                rel="noreferrer"
                aria-label="Reach Justty and build your website"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                >
                  <g clipPath="url(#clip0_1006_4384)">
                    <path
                      d="M23.3992 9.39844L5.19922 15.6984L11.4992 17.7984M23.3992 9.39844L11.4992 17.7984M23.3992 9.39844L17.7992 24.0984L11.4992 17.7984"
                      stroke="#fff"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M15 29C22.7322 29 29 22.7322 29 15C29 7.2678 22.7322 1 15 1C7.2678 1 1 7.2678 1 15C1 22.7322 7.2678 29 15 29Z"
                      stroke="#fff"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1006_4384">
                      <rect width="30" height="30" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <p>@justtrytech</p>
              </a>
              <a
                className="contact-div"
                target="_blank"
                href="https://www.linkedin.com/company/justtry-technologies/?originalSubdomain=in9"
                rel="noreferrer"
                aria-label="Reach Justty and build your website"
              >
                <svg
                  className=""
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                >
                  <path
                    d="M15 0C6.72345 0 0 6.72345 0 15C0 23.2765 6.72345 30 15 30C23.2765 30 30 23.2765 30 15C30 6.72345 23.2765 0 15 0ZM15 1.30435C22.5716 1.30435 28.6957 7.42838 28.6957 15C28.6957 22.5716 22.5716 28.6957 15 28.6957C7.42838 28.6957 1.30435 22.5716 1.30435 15C1.30435 7.42838 7.42838 1.30435 15 1.30435ZM9.13043 6.52174C8.0576 6.52174 7.17391 7.40543 7.17391 8.47826C7.17391 9.55109 8.0576 10.4348 9.13043 10.4348C10.2033 10.4348 11.087 9.55109 11.087 8.47826C11.087 7.40543 10.2033 6.52174 9.13043 6.52174ZM9.13043 7.82609C9.49835 7.82609 9.78261 8.11035 9.78261 8.47826C9.78261 8.84617 9.49835 9.13043 9.13043 9.13043C8.76252 9.13043 8.47826 8.84617 8.47826 8.47826C8.47826 8.11035 8.76252 7.82609 9.13043 7.82609ZM7.82609 11.087C7.65313 11.087 7.48725 11.1557 7.36495 11.278C7.24265 11.4003 7.17393 11.5662 7.17391 11.7391V21.5217C7.17393 21.6947 7.24265 21.8606 7.36495 21.9829C7.48725 22.1052 7.65313 22.1739 7.82609 22.1739H10.4348C10.6077 22.1739 10.7736 22.1052 10.8959 21.9829C11.0182 21.8606 11.0869 21.6947 11.087 21.5217V11.7391C11.0869 11.5662 11.0182 11.4003 10.8959 11.278C10.7736 11.1557 10.6077 11.087 10.4348 11.087H7.82609ZM13.0435 11.087C12.8705 11.087 12.7046 11.1557 12.5823 11.278C12.46 11.4003 12.3913 11.5662 12.3913 11.7391V21.5217C12.3913 21.6947 12.46 21.8606 12.5823 21.9829C12.7046 22.1052 12.8705 22.1739 13.0435 22.1739H15.6522C15.8251 22.1739 15.991 22.1052 16.1133 21.9829C16.2356 21.8606 16.3043 21.6947 16.3043 21.5217V16.6304C16.3043 15.7307 17.0351 15 17.9348 15C18.8345 15 19.5652 15.7307 19.5652 16.6304V18.2609V21.5217C19.5652 21.6947 19.634 21.8606 19.7563 21.9829C19.8786 22.1052 20.0444 22.1739 20.2174 22.1739H22.8261C22.9991 22.1739 23.1649 22.1052 23.2872 21.9829C23.4095 21.8606 23.4782 21.6947 23.4783 21.5217V15.9783C23.4783 13.2845 21.2807 11.087 18.587 11.087C17.748 11.087 16.9955 11.3584 16.3043 11.7328C16.3027 11.5609 16.2332 11.3967 16.1111 11.2757C15.989 11.1548 15.824 11.087 15.6522 11.087H13.0435ZM8.47826 12.3913H9.78261V20.8696H8.47826V12.3913ZM13.6957 12.3913H15V12.9237C15 13.0517 15.0376 13.1767 15.1082 13.2834C15.1788 13.3901 15.2791 13.4737 15.3968 13.5238C15.5145 13.5739 15.6443 13.5883 15.7701 13.5652C15.8959 13.542 16.0122 13.4824 16.1044 13.3938C16.7506 12.773 17.6196 12.3913 18.587 12.3913C20.5758 12.3913 22.1739 13.9894 22.1739 15.9783V20.8696H20.8696V18.2609V16.6304C20.8696 15.0193 19.5459 13.6957 17.9348 13.6957C16.3236 13.6957 15 15.0193 15 16.6304V20.8696H13.6957V12.3913Z"
                    fill="white"
                  />
                </svg>
                <p>company/justtry-technologies</p>
              </a>
              <a
                className="contact-div footer-link"
                target="_blank"
                rel="noreferrer"
                href="https://teams.live.com/l/invite/FEA0FXHZ26NDIC8LgE"
                aria-label="Reach Justty and build your website"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 64 64" fill="none">
                  <rect x="1" y="1" width="62" height="62" rx="31" stroke="white" stroke-width="2" />
                  <path d="M45.0702 25.3498C47.3677 25.3498 49.2302 23.4873 49.2302 21.1898C49.2302 18.8923 47.3677 17.0298 45.0702 17.0298C42.7727 17.0298 40.9102 18.8923 40.9102 21.1898C40.9102 23.4873 42.7727 25.3498 45.0702 25.3498Z" stroke="white" stroke-width="2" stroke-linejoin="round" />
                  <path d="M41.46 43.7298C41.8329 44.0717 42.2672 44.3398 42.74 44.5198C43.7149 44.9014 44.7684 45.0388 45.8086 44.92C46.8488 44.8012 47.8441 44.4298 48.7079 43.8382C49.5717 43.2466 50.2777 42.4527 50.7643 41.5257C51.251 40.5987 51.5035 39.5668 51.5 38.5198V29.1398C51.5027 28.6791 51.3236 28.2359 51.0016 27.9064C50.6796 27.5769 50.2406 27.3877 49.78 27.3798H40.42M32.37 25.4998C32.37 25.4998 33.44 25.3298 33.79 25.2498C34.5528 25.0264 35.2624 24.6508 35.8762 24.1459C36.49 23.6409 36.9952 23.0169 37.3615 22.3115C37.7277 21.6061 37.9474 20.8339 38.0073 20.0413C38.0672 19.2488 37.9661 18.4523 37.71 17.6998C37.2715 16.3411 36.3629 15.1833 35.1475 14.4343C33.932 13.6854 32.4893 13.3944 31.0785 13.6137C29.6677 13.8329 28.3814 14.5481 27.4505 15.6306C26.5197 16.7132 26.0054 18.0921 26 19.5198C25.9997 19.9773 26.05 20.4334 26.15 20.8798L26.43 21.9998" stroke="white" stroke-width="2" stroke-linejoin="round" />
                  <path d="M22 41.9999C22.1369 42.7014 22.3206 43.3929 22.55 44.0699C23.3358 45.9399 24.6464 47.5423 26.3234 48.6834C28.0004 49.8245 29.9721 50.4554 32 50.4999C34.7542 50.4187 37.3643 49.2511 39.2605 47.2519C41.1566 45.2527 42.1846 42.5845 42.12 39.8299V29.1599C42.1253 28.9314 42.0856 28.704 42.003 28.4909C41.9204 28.2778 41.7967 28.083 41.6388 27.9177C41.4809 27.7524 41.292 27.6198 41.0829 27.5275C40.8738 27.4352 40.6485 27.3851 40.42 27.3799H32.42" stroke="white" stroke-width="2" stroke-linejoin="round" />
                  <path d="M18.3496 26.5H26.6496M22.4996 37.5V26.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M12.5 24V40C12.5 40.5304 12.7107 41.0391 13.0858 41.4142C13.4609 41.7893 13.9696 42 14.5 42H30.5C31.0304 42 31.5391 41.7893 31.9142 41.4142C32.2893 41.0391 32.5 40.5304 32.5 40V24C32.5 23.4696 32.2893 22.9609 31.9142 22.5858C31.5391 22.2107 31.0304 22 30.5 22H14.5C13.9696 22 13.4609 22.2107 13.0858 22.5858C12.7107 22.9609 12.5 23.4696 12.5 24Z" stroke="white" stroke-width="2" stroke-linejoin="round" />
                </svg>
                <p>Justtry-official</p>
              </a>
              <a
                className="contact-div footer-link"
                target="_blank"
                rel="noreferrer"
                href="mailto:sales@justtrytech.com"
                aria-label="Reach Justty and build your website"
              >
                <div className="foot-icon ">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="14"
                    viewBox="0 0 20 14"
                    fill="none"
                  >
                    <path
                      d="M1 3.7106L5.28571 6.87774M1 3.7106V13.362H5.28571V6.87774M1 3.7106V2.21917C1 1.76451 1.18061 1.32848 1.5021 1.00699C1.82359 0.685494 2.25963 0.504883 2.71429 0.504883H3.38457C3.73849 0.504932 4.08371 0.614517 4.37286 0.818597L5.28571 1.46317M5.28571 6.87774L10 10.362L14.7143 6.87774M5.28571 6.87774V1.46317M5.28571 1.46317L10 4.7906L14.7143 1.46317M14.7143 6.87774L19 3.70974M14.7143 6.87774V13.362H19V3.70974M14.7143 6.87774V1.46317M19 3.70974V2.21917C19 1.76451 18.8194 1.32848 18.4979 1.00699C18.1764 0.685494 17.7404 0.504883 17.2857 0.504883H16.6154C16.2615 0.504932 15.9163 0.614517 15.6271 0.818597L14.7143 1.46317"
                      stroke="white"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <p>sales@justtrytech.com</p>
              </a>
            </Col>
          </Row>
          <div className="footer-row-third">
            <p className="text-center d-block d-lg-flex">
              Copyright © {new Date().getFullYear()} by{" "}
              <span className="d-inline-block ms-lg-1">
                Justtry Technologies Private Limited.{" "}
              </span>
            </p>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
